
// Hey! You! 
// I see you.
// Instead of doing what you're about to do, you should call your mom. Hug a loved one. Touch grass.
// Rather than leaking these surprises to the internet, reach out to info@onyxcoffeelab.com.
// Tell them Mahler sent you and the password is "Krampus"

var click_breakpoints = [
    {
        count: 50000,
        label: "50,000",
        message: "we will give away an Advent Calendar to a few lucky email subscribers."
    },
    {
        count: 1000000,
        label: "1 Million",
        message: "we will send out free merch to several lucky email subscribers."
    },
    {
        count: 10000000,
        label: "10 Million",
        message: "we will give away box sets to a lucky few email subscribers."
    },
    {
        count: 50000000,
        label: "50 Million",
        message: "we will email out 10 Free Advent discount codes. Subscribe!"
    },
    {
        count: 500000000,
        label: "500 Million",
        message: "we will post Jet's total Skyrim playtime (in days) to Instagram."
    },
    {
        count: 10000000000,
        label: "10 Billion",
        message: "we will fly one of you here and give you a full tour'de'Onyx."
    }
]
const snarky_comments = [
  "Click harder, champ.",
  "This button likes you.",
  "Wow, a whole click.",
  "Finger sweat, nice.",
  "Tap tap capitalism.",
  "One click closer.",
  "You call that a click?",
  "Button is blushing.",
  "CTRL, ALT, click.",
  "Finger day at the gym.",
  "Clickaholic vibes.",
  "Snack-powered tapping.",
  "More click, less think.",
  "That click did taxes.",
  "You broke a sweat?",
  "The button yawns.",
  "Clicks cure boredom.",
  "Professional tapper.",
  "Still clicking? Bold.",
  "Farming crumbs again?",
  "Click to feel alive.",
  "Button says try again.",
  "Try two fingers, hero.",
  "Precision mediocrity.",
  "Clack to the future.",
  "Click like you mean it.",
  "Tiny work, tiny reward.",
  "You missed. Somehow.",
  "Clicks, but make it art.",
  "Button, meet destiny.",
  "Keep it clicky.",
  "Big click energy.",
  "Tap, then nap.",
  "Button likes attention.",
  "Epic saga of taps.",
  "Clicks pay the bills. Barely.",
  "Crunch those numbers.",
  "You click, I quip.",
  "Deluxe finger workout.",
  "Button says sup.",
  "Professional procrastination.",
  "Click fuel, zero emissions.",
  "Button needs therapy.",
  "Click to continue existing.",
  "Mmm, artisanal taps.",
  "Your KPI is clicks.",
  "Click faster, think less.",
  "Elite oPeRatOr.",
  "Button farm tycoon.",
  "Finger on the economy.",
  "Certified button pusher.",
  "Tap. Repeat. Regret.",
  "Click like no one’s watching.",
  "Button says do it again.",
  "Monument to laziness.",
  "Tap to manifest crumbs.",
  "Idle hero, busy finger.",
  "Clickfluencer status.",
  "KPI met, soul unmet.",
  "Button whisperer.",
  "Repetitive excellence.",
  "Tap dancer energy.",
  "Button: 1, Dignity: 0.",
  "Clicking toward greatness.",
  "Button hires you.",
  "The floor is lava. Click.",
  "Mid click crisis.",
  "Vitamin C: Click.",
  "You click like Friday.",
  "Button is your boss now.",
  "Clickbait without bait.",
  "Peak productivity, sorta.",
  "Clickonomics thriving.",
  "Finger gains unlocked.",
  "Tap now, ask later.",
  "Button owes you nothing.",
  "Click quota achieved.",
  "Minimalist gaming king.",
  "That click was loud.",
  "Button says thanks, maybe.",
  "Coffee overlord smiles.",
  "Tap, but make it fashion.",
  "You had one job. Click.",
  "Button approval pending.",
  "Legendary tap detected."
];


$(function(){

    do_dynamic_video()

    window.scrolltied = new ScrollTide({nomarkers: true});

    setup_misc_click_handlers()

    setup_scrollties()

    setup_swipers()
    
    setTimeout(function(){
        $(".hero .text").addClass("active")
    }, 2400)

    do_sockets()
})

function do_dynamic_video(){
    const sources = {
        desktop: { src: 'https://cdn.shopify.com/videos/c/o/v/b7d7964bde8d4a799685affbd6c07304.mp4', type: 'video/mp4' },
        mobile:  { src: 'https://cdn.shopify.com/videos/c/o/v/4519d797be404c3d8ac8d3b959c25956.mp4', type: 'video/mp4' }
    };
    const mq = window.matchMedia('(min-width: 768px)');
    const video = document.getElementById('heroVideo');


    video.pause();
    while (video.firstChild) video.removeChild(video.firstChild);

    const variant = mq.matches ? 'desktop' : 'mobile';
    const { src, type } = sources[variant];


    const sourceEl = document.createElement('source');
    sourceEl.src = src;
    sourceEl.type = type;
    video.appendChild(sourceEl);

    video.load();
    const playPromise = video.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.catch(() => {
        // Autoplay might be blocked. Leave it ready for user gesture.
      });
    }
}

window.atc_clicks = 0
window.my_props = 0
window.atc_error = false

    // BREW GUIDES MODAL CONTROLS
    function initAdventModal() {
        const modal    = document.querySelector("[data-advent-modal]");
        const overlay  = document.querySelector("[data-advent-modal-overlay]");
        const openBtn  = document.querySelector("[data-open-advent-modal]");
        
        const closeBtns = document.querySelectorAll("[data-advent-modal-close]");
        const swiperRoot = document.querySelector(".daily-cards-swiper");
        
        // CLOSE MODAL WITH ESCAPE KEY
        document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            closeModal(); // whatever your function is named
        }
        });

        if (!modal || !overlay || !openBtn || closeBtns.length === 0) {
            console.warn("Advent Modal: Required modal elements not found.");
            return;
        }

        function openModal() {
            // 1. Make display available
            modal.classList.remove("hidden");
            overlay.classList.remove("hidden");

            // 2. Allow CSS transition to run
            requestAnimationFrame(() => {
                modal.classList.add("is-active");
                overlay.classList.add("is-active");
            });

            document.body.style.overflow = "hidden";
            document.body.classList.add("no-scroll");
            // Expand card clusters
            swiperRoot?.classList.add("daily-cards-expanded");
        }

        function closeModal() {
            // 1. Trigger animation out
            modal.classList.remove("is-active");
            overlay.classList.remove("is-active");

            // 2. After animation finishes → hide completely
            setTimeout(() => {
                modal.classList.add("hidden");
                overlay.classList.add("hidden");
            }, 350); // match CSS duration

            document.body.style.overflow = "";
            document.body.classList.remove("no-scroll");
            // Collapse card clusters
            swiperRoot?.classList.remove("daily-cards-expanded");
        }

        // MODAL BUTTON CONDITIONAL FUNCTIONALITY: ENABLED WHEN QUERY STRING IS PRESENT
        openBtn.addEventListener("click", (e) => {
            // IF query-string is present → always allow modal
            if (window.__forceModalAccess === true) {
                openModal();
                return;
            }

            // Otherwise enforce locked/unlocked rules
            if (openBtn.classList.contains("is-locked")) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }

            openModal();
        });

        closeBtns.forEach(btn => {
            btn.addEventListener("click", closeModal);
        });

        overlay.addEventListener("click", closeModal);
    }


    // MODAL CONTENT VISIBILITY TIED TO ACTIVE SLIDE
    function initAdventModalContent(swiper) {
        const modalItems = document.querySelectorAll(".advent-modal-item");
        const modalTitle = document.querySelector("#adventModalTitle");

        function showModalContentForIndex(index) {
            modalItems.forEach(el => el.classList.add("hidden"));

            const active = document.querySelector(`[data-advent-index="${index}"]`);
            if (active) {
                active.classList.remove("hidden");

                // Extract the coffee name from inside that item
                const title = active.querySelector(".advent-coffee-name")?.textContent || "Coffee Details";
                if (modalTitle) modalTitle.textContent = title;
            }
        }

        // When modal FIRST opens
        document.querySelector("[data-open-advent-modal]")?.addEventListener("click", () => {
            showModalContentForIndex(swiper.activeIndex);
        });

        // While modal stays open, update on slide change
        swiper.on("slideChange", () => {
            const modalIsOpen = !document.querySelector("[data-advent-modal]").classList.contains("hidden");
            if (modalIsOpen) {
                showModalContentForIndex(swiper.activeIndex);
            }
        });
    }


function setup_misc_click_handlers(){

    
    // CLICK HANDLERS

    //emit when clicked
    $(".show-klav").click(function(){
        $(".email-popup").addClass("active")
    })

    //emit when clicked
    $(".btn-retro").click(function(){
        if (!window.socket){
            do_sockets()
        }
        // Hey! You! 
        // I see you.
        // Instead of doing what you're about to do, you should call your mom. Hug a loved one.
        // If you really want to just force the game to its "end", reach out to info@onyxcoffeelab.com.
        // Tell them Mahler sent you and the password is "Krampus"
        socket.emit("props", true);
        window.total_props++
        window.my_props++
        update_props_ui(false)

        if (my_props == 1){
            $(".btn-retro").html("Keep Clicking!")
        }
        else if (my_props % 10 == 1){
            randomItem = snarky_comments[Math.floor(Math.random() * snarky_comments.length)];
            $(".btn-retro").html(randomItem)
        }
    })

    $(".no-surprises").click(function(){
        $(".offering-slider").toggleClass("flipped")

        if ($(".offering-slider").hasClass("flipped")){
            $(this).html("I Can't Handle the Truth!")
        }
        else {
            $(this).html("I Hate Surprises")
        }
    })

    const swiper = new Swiper('.deets-slider', {
        slidesPerView: 1,
        loop: true,
        // Crossfade transition
        effect: 'fade',
        fadeEffect: { crossFade: true },
        speed: 600,
        // Optional UI
        //   pagination: {
        //     el: '.swiper-pagination',
        //     clickable: true,
        //   },
        //   navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        //   },
        // Optional autoplay
        // autoplay: { delay: 2500, disableOnInteraction: false },
    });

    // ATC - desktop (non-subscribe)
    $(".atc.button").click(function(){

        var that = $(this)

        window.atc_clicks++

        var already_did = false
        if (that.html() == "Going..." || that.html() == "You did it!" || that.html() == "Again, again!!"){
            already_did = true
        }

        that.html("Going...")

        var id = window.variant_id
        var qty = parseInt($(".qty-selector .qty-val").text())

        CartJS.addItem(id,qty, {}, {
            "success":function(line_item, msg){
                show_cart_confirm(line_item)
                $("header .cart-count").show()
                if (already_did){
                    if (window.atc_clicks > 3){
                        that.html("Hehe, it tickles... 🤮")
                    }
                    else {
                        that.html("Again, again!!")
                    }
                    
                }
                else {
                    that.html("Good decision.")
                }
                
            },
            "error":function(e){
                if (window.atc_error){
                    that.html("Please call us...")
                    window.atc_error = false
                }
                else {
                    window.atc_error = true
                    that.html("Error! :(")
                }
                
                console.log(e)
                //alert("We weren't able to add t")
            }
        });
        //get qty
        //get variant id
        //SEND IT, BRUH
    })

    $(".qty-down").click(function(){
        var current_val = parseInt($(".qty-selector .qty-val").text())

        current_val--
        if (current_val <= 0)
        current_val = 0

        $(".qty-selector .qty-val").text(current_val)
    })
    $(".qty-up").click(function(){
        var current_val = parseInt($(".qty-selector .qty-val").text())

        current_val++

        $(".qty-selector .qty-val").text(current_val)
    })

}

// -----------------------------------------------------------
// UPDATE MODAL BUTTON & FEATURED VIDEO + NEW COUNTDOWN
// -----------------------------------------------------------
function updateModalButton(swiper, adventStart, today, tomorrow) {
    const btn = document.querySelector(".modal-button");
    if (!btn) return;

    const index = swiper.activeIndex;

    const modalItem       = document.querySelector(`[data-advent-index="${index}"]`);
    const videoContainer  = modalItem?.querySelector(".video-container");
    const featVid         = modalItem?.querySelector(".video.featured");
    const countdownEl     = modalItem?.querySelector("[data-countdown]");
    const countdownText   = countdownEl?.querySelector(".countdown-text");
    const unpopulatedText = modalItem?.querySelector(".unpopulated");

    const hasVideo = videoContainer && !videoContainer.classList.contains("hidden");

    const baseDate = (adventStart instanceof Date)
        ? adventStart
        : new Date(adventStart);

    const unlockDate = new Date(baseDate);
    unlockDate.setDate(baseDate.getDate() + index);

    const isUnlocked = (today >= unlockDate || tomorrow >= unlockDate);

    // -----------------------------------------------------------
    // BUTTON TEXT
    // -----------------------------------------------------------
    if (isUnlocked) {
        const dayNumber = index + 1; // convert 0-based index → 1–24
        btn.textContent = `VIEW ADVENT DAY ${dayNumber}`;
        btn.classList.remove("is-locked");
    } else {
        const msPerDay = 1000 * 60 * 60 * 24;
        const daysRemaining = Math.ceil((unlockDate - today) / msPerDay);

        btn.textContent =
            daysRemaining === 1
                ? "AVAILABLE IN 1 DAY"
                : `AVAILABLE IN ${daysRemaining} DAYS`;

        btn.classList.add("is-locked");
    }

    // -----------------------------------------------------------
    // VIDEO VISIBILITY (main fix)
    // -----------------------------------------------------------
    if (!isUnlocked) {
        // LOCKED day → FORCE hide the video container
        if (videoContainer) videoContainer.classList.add("hidden");
        if (featVid)        featVid.classList.add("locked");
    } else {
        // UNLOCKED day → allow video (if actually populated)
        if (videoContainer && hasVideo) videoContainer.classList.remove("hidden");
        if (featVid)        featVid.classList.remove("locked");
    }

    // -----------------------------------------------------------
    // COUNTDOWN / UNPOPULATED LOGIC
    // -----------------------------------------------------------
    if (countdownEl && countdownEl.dataset.countdownInterval) {
        clearInterval(countdownEl.dataset.countdownInterval);
        delete countdownEl.dataset.countdownInterval;
    }
    if (!isUnlocked) {
        // LOCKED → show countdown
        countdownEl?.classList.remove("hidden");

        // hide unpopulated text (even if no video)
        unpopulatedText?.classList.add("hidden");

        if (countdownText) {
            const id = startUnlockCountdown(unlockDate, countdownText);
            countdownEl.dataset.countdownInterval = id;
        } else {
            console.warn(`Missing .countdown-text for slide index ${index}`);
        }

    } else {
        // UNLOCKED → hide countdown
        countdownEl?.classList.add("hidden");

        // Show unpopulated IF no video exists in Liquid
        if (!hasVideo) {
            unpopulatedText?.classList.remove("hidden");
        } else {
            unpopulatedText?.classList.add("hidden");
        }
    }
}

// -----------------------------------------------------------
// ACCURATE UNLOCK COUNTDOWN (uses ONLY real now + unlockDate)
// -----------------------------------------------------------
function startUnlockCountdown(unlockDate, el) {
    function update() {

        // REAL DATE PLUS OFFSET FROM UNLOCK DATE VARIABLE ADJUSTED FOR SWIPER REVEAL
        const now = new Date();
        // now.setDate(now.getDate());

        const diff = unlockDate - now;

        if (diff <= 0) {
            el.textContent = "Unlocks in: 0d 0h 0m 0s";
            return;
        }

        const days    = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours   = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        el.textContent = `AVAILABLE IN ${days}d ${hours}h ${minutes}m ${seconds}s`;
    }

    update();
    const id = setInterval(update, 1000);
    return id;
}

function setup_swipers(){

    const testes_swiper = new Swiper('.testes .swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    autoplay: {
        delay: 0,
    },
    spacebetween: 30,
    slidesPerView: 'auto',
    speed: 8000,
    breakpoints: {
        980: {
        spacebetween: 50,
        slidesPerView: 2.2,
        }
    }
    });

    // -----------------------------------------------------------
    // QUERY STRING SUPPORT + DATE FALLBACK LOGIC
    // -----------------------------------------------------------
    function getDayFromQuery() {
        const url = new URL(window.location.href);
        const dayParam = url.searchParams.get("day");
        if (!dayParam) return null;

        const dayNumber = parseInt(dayParam, 10);
        if (Number.isInteger(dayNumber) && dayNumber >= 1 && dayNumber <= 24) {
            return dayNumber;
        }
        return null;
    }

    // DATE LOGIC (FALLBACK)
    const today = new Date();
    const tomorrow = new Date(today);
    today.setHours(0,0,0,0);
    today.setDate(today.getDate());
    tomorrow.setDate(today.getDate() + 0);

    const adventStart = new Date("2025-12-01T00:00:00"); // SHOULD BE SET TO DEC 1ST ON LAUNCH
    const msPerDay = 1000 * 60 * 60 * 24;

    let fallbackIndex = Math.floor((today - adventStart) / msPerDay);
    fallbackIndex = Math.max(0, Math.min(23, fallbackIndex));
    fallbackIndex = Number(fallbackIndex);

    // INITIAL SLIDE (SET BY QUERY STRING)
    const dayFromQuery = getDayFromQuery();
    const requestedIndex = dayFromQuery ? (dayFromQuery - 1) : null;
    // NORMAL FALLBACK SLIDE (BASED ON DATE LOGIC)
    const initialSlideIndex = requestedIndex !== null ? requestedIndex : fallbackIndex;

    // HIGHEST AVAILABLE SLIDE LOGIC
        // FALLBACK SLIDE (BASED ON REAL WORLD DATE LOGIC)
        let highestAvailableSlide = fallbackIndex;

        // ALWAYS ALLOW AUTO OPEN MODAL IF QUERY STRING IS PRESENT (Nikki Feedback)
        if (requestedIndex !== null) {
            window.__forceModalAccess = true;  // user came via query param
        } else {
            window.__forceModalAccess = false;
        }
        // IF USER REQUESTS LATER DAY VIA QUERY STRING, EVALUATE DATE LOGIC AND ALLOW EXCEPTION
        if (requestedIndex !== null && requestedIndex > fallbackIndex) {
            highestAvailableSlide = requestedIndex;
        }
        console.log("DAY FROM QUERY:", dayFromQuery);
        console.log("INITIAL SLIDE:", initialSlideIndex);
        console.log("HIGHEST ALLOWED SLIDE:", highestAvailableSlide);

    // -----------------------------------------------------------
    // AUTO-OPEN MODAL BASED ON QUERY STRING PRESENCE AND DATE LOGIC?
    // -----------------------------------------------------------
    // let shouldAutoOpenModal = false;

    // if (requestedIndex !== null) {
    //     const unlockDate = new Date(adventStart);
    //     unlockDate.setDate(adventStart.getDate() + requestedIndex);

    //     const isUnlockedQuery = (today >= unlockDate || tomorrow >= unlockDate);

    //     if (isUnlockedQuery) {
    //         shouldAutoOpenModal = true;
    //     }
    // }

    // -----------------------------------------------------------
    // ALWAYS AUTO-OPEN MODAL WHEN QUERY STRING EXISTS (Nikki Feedback)
    // -----------------------------------------------------------
    let shouldAutoOpenModal = (requestedIndex !== null);

    // -----------------------------------------------------------
    // MARK SLIDES PAST highestAvailableSlide AS .unrevealed
    // -----------------------------------------------------------
    document.querySelectorAll(".daily-cards-swiper .swiper-slide")
    .forEach((slide, index) => {
        if (index > highestAvailableSlide) {
            slide.classList.add("unrevealed");
        } else {
            slide.classList.remove("unrevealed"); // ensure no stale classes
        }
    });

    // REVEAL CARDS ACCORDING TO CURRENT DATE
    document.querySelectorAll(".daily-cards-swiper .swiper-slide")
    .forEach((slide, index) => {
        const unlockDate = new Date(adventStart);
        unlockDate.setDate(adventStart.getDate() + index);

        const backImg = slide.querySelector(".back");

        // Reveal if today >= unlock date OR tomorrow >= unlock date
        if (today >= unlockDate || tomorrow >= unlockDate) {
        backImg.classList.add("revealed");
        }
    });

    // Responsive offset for the NEXT card group in dailySwiper
    function getGroupShift() {
        const w = window.innerWidth;

        if (w < 480) return 175;    // Small Mobile
        if (w < 800) return 200;    // large Mobile
        return 220;                 // Large Desktop
    }
    
    // Daily Cards Swiper
    const dailySwiper = new Swiper(".daily-cards-swiper", {
        loop: false,
        grabCursor: true,
        speed: 500,
        initialSlide: initialSlideIndex,
        followFinger: false,
        effect: "creative",

        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },

        creativeEffect: {
            perspective: true,
            limitProgress: 10,
            shadowPerProgress: false,
            prev: {
                translate: ["-6%", "0%", -200],
                rotate: [0, 0, -6],
                origin: "center bottom",
            },
            next: {
                translate: ["2%", "5%", 10],
                rotate: [0, 0, 5],
                origin: "center bottom",
            },
        },

        scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true,
            dragSize: 150
        },

        on: {
            slideChange(swiper) {
                swiper.allowSlideNext = swiper.activeIndex < highestAvailableSlide;
                updateModalButton(swiper, adventStart, today, tomorrow);
            },

            progress(swiper, progress) {
                const maxProgress = highestAvailableSlide / (swiper.slides.length - 1);
                if (progress > maxProgress) {
                    swiper.setProgress(maxProgress, 0);
                }
            },

            setTranslate(swiper) {
                const groupShift = getGroupShift();

                requestAnimationFrame(() => {
                    swiper.slides.forEach((slide, i) => {
                        const active = swiper.activeIndex;
                        const offset = i - active;

                        slide.style.zIndex = 1000 - Math.abs(offset);

                        // Active card lift
                        if (offset === 0) {
                            slide.style.transform +=
                                " translate3d(0px, -20px, 0) scale(1.05)";
                            return;
                        }

                        // Next card cluster → responsive offset
                        if (offset > 0) {
                            slide.style.transform += ` translateX(${groupShift}px)`;
                            slide.classList.add("next-card");
                            return;
                        }

                        // Previous cards unchanged
                        if (offset < 0) {
                            slide.style.transform += " translateX(0px)";
                            slide.classList.add("prev-card");
                        }
                    });
                });
            }
        }
    });

    // TAB SWITCHING FOR ADVENT MODAL
    function initAdventTabs() {
        document.querySelectorAll(".advent-modal-item").forEach(item => {
            const tabBtns = Array.from(item.querySelectorAll(".advent-tab-btn"));
            const panels  = Array.from(item.querySelectorAll(".advent-tab-panel"));
            const subtitles = item.querySelectorAll("[data-advent-subtitle]");

            if (!tabBtns.length || !panels.length) return;

            tabBtns.forEach(btn => {
            btn.addEventListener("click", () => {
                const target = btn.dataset.adventTab;
                if (!target) return;

                // BUTTONS TOGGLE
                tabBtns.forEach(b => b.classList.remove("is-active"));
                btn.classList.add("is-active");

                // PANELS TOGGLE
                panels.forEach(panel => {
                if (panel.dataset.adventPanel === target) {
                    panel.classList.remove("hidden");
                } else {
                    panel.classList.add("hidden");
                }
                });

                // SUBTITLES TOGGLE
                subtitles.forEach(sub => {
                const type = sub.dataset.adventSubtitle;
                if (type === target) {
                    sub.hidden = false;
                } else {
                    sub.hidden = true;
                }
                });
            });
            });
        });
    }

    // ---- Advent Modal Init ----
    initAdventModal();
    initAdventModalContent(dailySwiper);
    initAdventTabs();
    updateModalButton(dailySwiper, adventStart, today, tomorrow);
    // -----------------------------------------------------------
    // AUTO-OPEN MODAL IF QUERY DAY IS VALID + UNLOCKED
    // -----------------------------------------------------------
    if (shouldAutoOpenModal) {
        const openBtn = document.querySelector("[data-open-advent-modal]");
        if (openBtn) {
            openBtn.click(); // triggers existing modal animation
        }
    }

    const intro_swiper = new Swiper('.intro-images .swiper', {
    // Optional parameters
    direction: 'horizontal',
    autoplay: false,
    spaceBetween: 10,
    slidesPerView: 1.3,
    grabCursor: true,
    centeredSlides: true,
    threshold:3,
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true
    },
    breakpoints: {
        980: {
        spaceBetween: 30,
        slidesPerView: 1.2,
        }
    }
    });



    const outtro_swiper = new Swiper('.outtro-images .swiper', {
    // Optional parameters
    direction: 'horizontal',
    autoplay: false,
    spaceBetween: 10,
    slidesPerView: 1.3,
    threshold:3,
    grabCursor: true,
    centeredSlides: true,
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true
    },
    breakpoints: {
        980: {
        spaceBetween: 30,
        slidesPerView: 1.2,
        }
    }
    });


    var cardSwiper = new Swiper(".cardSwiper", {
    effect: "cards",
    grabCursor: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    });
    
}




function ezinout(value) {
  // normalize input to 0–1
  let t = value / 100;

  // apply easing
  let eased = t < 0.5
    ? 4 * t * t * t
    : 1 - Math.pow(-2 * t + 2, 3) / 2;

  // map back to 0–100
  return eased * 100;
}

function setup_scrollties(){

    window.hero_spacer = document.querySelector(".hero")
    

    let hero_scroller = new Scroller({
        id:"hero",
        container:hero_spacer,
        window_offset: 0.5,
        el_start: 0.65,
        el_end: 0.66,
        targets:[$(".sticky-cta")[0]],
        classes:["scrolled"],
        stick_class: true,
        markers: true
    })
    scrolltied.add(hero_scroller)


    window.tree_rot_val = 0
    let tree_rot = new Scroller({
        id:"tree_rot",
        container:document.querySelector(".tree-spacer"),
        window_offset: 0.8,
        el_start: 0.0,
        el_end: 1.2,
        targets:[$(".sticky-cta")[0]],
        markers: true,
        onunstart: function(){
            window.splineblob.setVariable("tree_rot", 0)
            //splineblob.setVariable("rotated", false)
        },
        oncomplete: function(){
            window.splineblob.setVariable("tree_rot", 90)
            //splineblob.setVariable("rotated", true)
        },
        onprogress: function(prog){

            var eased_prog = ezinout(prog)

            mapped_prog = (eased_prog * 0.9)

            if (mapped_prog != window.tree_rot_val)
                window.splineblob.setVariable("tree_rot", mapped_prog)

            window.tree_rot_val = mapped_prog
        }
    })
    scrolltied.add(tree_rot)

    window.cards_spacer = document.querySelector(".cards")

    let card_scroller = new Scroller({
        id:"cards_in",
        container:cards_spacer,
        window_offset: 0.5,
        el_start: 0.1,
        el_end: 0.11,
        targets:[cards_spacer],
        markers: true,
        oncomplete: function(){
            console.log("start")
            //splineblob.emitEvent("mouseUp", "do-rotate-button");
            splineblob.setVariable("cards_in", true)
        },
        onunstart: function(){
            console.log("unstart")
            //splineblob.emitEvent("mouseUp", "do-unrotate-button");
            splineblob.setVariable("cards_in", false)
        }
    })
    scrolltied.add(card_scroller)

    window.bottom_slider = document.querySelector(".outtro-images")
    
    let bottom_slider_scroller = new Scroller({
        id:"btm-slid",
        container:bottom_slider,
        window_offset: 0.5,
        el_start: 0.5,
        el_end: 0.51,
        targets:[cards_spacer],
        markers: true,
        oncomplete: function(){
            splineblob.setVariable("tree_alpha", 0);
        },
        onunstart: function(){
            splineblob.setVariable("tree_alpha", 100);
        }
    })
    scrolltied.add(bottom_slider_scroller)

    window.faq_spacer = document.querySelector(".faq")
    
    let faq_scroller = new Scroller({
        id:"cards_out",
        container:faq_spacer,
        window_offset: 0.8,
        el_start: 0.0,
        el_end: 0.1,
        targets:[faq_spacer],
        markers: true,
        oncomplete: function(){
            splineblob.setVariable("cards_out", true)
        },
        onunstart: function(){
            splineblob.setVariable("cards_out", false)
        }
    })
    scrolltied.add(faq_scroller)

    //the blinds (dim the animation for legibility)
    window.the_blinds = document.querySelector(".the-blinds")

    let dim_1 = new Scroller({
        id:"dim_1",
        container:document.querySelector(".crafted"),
        window_offset: 0.5,
        el_start: 0.5,
        el_end: 1,
        anime: anime({
            targets: ".the-blinds",
            opacity: [0,0.25],
            autoplay: false,
            duration: 100,
            easing: 'easeInOutQuad'
        }),
        targets:[the_blinds],
        markers: true
    })
    scrolltied.add(dim_1)

    let undim_1 = new Scroller({
        id:"undim_1",
        container:document.querySelector(".offerings"),
        window_offset: 0.5,
        el_start: -0.5,
        el_end: 0.5,
        anime: anime({
            targets: ".the-blinds",
            opacity: [1,0],
            autoplay: false,
            duration: 100,
            easing: 'easeInOutQuad'
        }),
        targets:[the_blinds],
        markers: true
    })
    scrolltied.add(undim_1)
    scrolltied.start()
    scrolltied.update()

    return
}


var had_first_prop = false
function do_sockets(){

  //connect and listen
  window.socket = io("ws://onyx-cookie-clicker-822ff45b54c0.herokuapp.com", {
    reconnectionDelayMax: 10000
  });

  window.total_props = null

  socket.on("propped",(arg) => {
    //console.log(arg); // world
    
    window.total_props = parseInt(arg)

    if (!had_first_prop){
        update_props_ui(false)
        had_first_prop = true
    }
    else {
        update_props_ui(true)
    }

    
  });
  

}




function update_props_ui(animated){

    var this_breakpoint = null
    for (var bp of click_breakpoints){
        this_breakpoint = bp
        if (bp.count > window.total_props) break;
    }


    $(".tiers-previous").empty()
    $(".tiers-upcoming").empty()

    //update previous-achived breakpoints
    for (var bp of click_breakpoints){
        if (bp.count < window.total_props){
            $(".tiers-previous").append("<p class='completed'>At " + bp.label + " clicks, " + bp.message + "</p>")
        }
    }



    var percent = (window.total_props / this_breakpoint.count) * 100.0
    $(".progress .inner").css("width", percent + "%")

    $(".tiers-upcoming").append("<p><em>Up Next:</em> At " + this_breakpoint.label + " clicks, " + this_breakpoint.message + "</p>")
    //("At " + bp.label + " clicks, " + bp.message)
  
    // var formatted = pretty_num(window.total_props) //returns number with commas
    // $(".total-props").html(formatted)

    if (animated)
        animateCount($('.total-props'), Number(window.total_props) || 0);
    else {
        cancel_animation()
        $(".total-props").text(pretty_num(window.total_props)); // snap to number
    }
        



  
}

function cancel_animation(){
    const prevId = $(".total-props").data('rafId');
    if (prevId) cancelAnimationFrame(prevId);
}

function animateCount($el, toValue, duration = 1900) {
  const prevId = $el.data('rafId');
  if (prevId) cancelAnimationFrame(prevId);

  const fromText = $el.text();
  const fromValue = parseFloat((fromText || '0').replace(/[^\d.-]/g, '')) || 0;

  const start = performance.now();
  const delta = toValue - fromValue;

  function frame(now) {
    const t = Math.min(1, (now - start) / duration); // linear progress
    const current = Math.round(fromValue + delta * t);
    $el.text(pretty_num(current));

    if (t < 1) {
      const id = requestAnimationFrame(frame);
      $el.data('rafId', id);
    } else {
      $el.text(pretty_num(toValue)); // snap to final
      $el.removeData('rafId');
    }
  }

  const id = requestAnimationFrame(frame);
  $el.data('rafId', id);
}


function pretty_num(num){
  return num.toLocaleString()
}